module.exports = __webpack_public_path__ + "img/lg_ring_g_o_1_null@2x.d0da1a71.png";